export default __webpack_public_path__ + "static/media/book-nav-icon6-completed.6595b41d.svg";